<li class="list-item">
    <a href="#"  (click)="scrollTo($event)" role="link" data-testid="listItemLink" [attr.aria-label]="itemName + ' same page'">{{itemName}}</a>
</li>